import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "grid grid-cols-12 gap-5 py-10 px-5 lg:px-2 cursor-default"
}
const _hoisted_2 = { class: "flex items-center gap-1" }
const _hoisted_3 = { class: "my-10" }
const _hoisted_4 = { for: "subdomain" }
const _hoisted_5 = { class: "grid grid-cols- gap-5 mb-10" }
const _hoisted_6 = { id: "logo-picker" }
const _hoisted_7 = { id: "partners-picker" }
const _hoisted_8 = {
  id: "colors",
  class: "grid grid-cols-1 gap-8 mb-10"
}
const _hoisted_9 = {
  id: "actions",
  class: "flex justify-end items-center gap-2"
}
const _hoisted_10 = {
  id: "preview",
  class: "col-span-12 xl:col-span-8 border-l-2 pl-5 hidden xl:block"
}
const _hoisted_11 = { class: "mb-8" }
const _hoisted_12 = { class: "font-bold text-lg mb-2" }
const _hoisted_13 = { class: "font-bold text-lg mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_ImagePicker = _resolveComponent("ImagePicker")!
  const _component_ColorPicker = _resolveComponent("ColorPicker")!
  const _component_PreviewColors = _resolveComponent("PreviewColors")!

  return (_ctx.loader)
    ? (_openBlock(), _createBlock(_component_Loader, {
        key: 0,
        loader: _ctx.loader
      }, null, 8, ["loader"]))
    : (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("form", {
          id: "form-theme",
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
          class: "col-span-12 xl:col-span-4"
        }, [
          _createElementVNode("header", _hoisted_2, [
            _createVNode(_component_Button, {
              icon: "pi pi-arrow-left",
              class: "btn-simple",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.go(-1)), ["prevent"]))
            }),
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t("theme.org.title")), 1)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("theme.org.form.subdomain")), 1),
            _createVNode(_component_InputText, {
              id: "subdomain",
              modelValue: _ctx.form.subdomain,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.subdomain) = $event)),
              class: "!mt-2",
              disabled: _ctx.disableDns
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(_component_Errors, {
              errors: _ctx.v$.subdomain.$errors
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_ImagePicker, {
                "input-id": "images",
                label: _ctx.$t('theme.org.form.logo'),
                modelValue: _ctx.form.logo,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.logo) = $event)),
                "max-files": 1,
                accept: "image/svg+xml",
                "onUpdate:removedFiles": _ctx.onRemoveFiles
              }, null, 8, ["label", "modelValue", "onUpdate:removedFiles"]),
              _createVNode(_component_Errors, {
                errors: _ctx.v$.logo.$errors
              }, null, 8, ["errors"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ImagePicker, {
                "input-id": "images/partners",
                label: _ctx.$t('theme.org.form.partners'),
                modelValue: _ctx.form.partners,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.partners) = $event)),
                "max-files": 5,
                accept: "image/svg+xml",
                "onUpdate:removedFiles": _ctx.onRemoveFiles
              }, null, 8, ["label", "modelValue", "onUpdate:removedFiles"]),
              _createVNode(_component_Errors, {
                errors: _ctx.v$.partners.$errors
              }, null, 8, ["errors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_ColorPicker, {
              modelValue: _ctx.colors.primary,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.colors.primary) = $event)),
              label: _ctx.$t('theme.org.primary')
            }, null, 8, ["modelValue", "label"]),
            _createVNode(_component_ColorPicker, {
              modelValue: _ctx.colors.secondary,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.colors.secondary) = $event)),
              label: _ctx.$t('theme.org.secondary')
            }, null, 8, ["modelValue", "label"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Button, {
              label: _ctx.$t('labels.cancel'),
              class: "btn-outline",
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.goBack()), ["prevent"]))
            }, null, 8, ["label"]),
            _createVNode(_component_Button, {
              type: "submit",
              label: _ctx.$t('labels.save'),
              class: "btn-primary"
            }, null, 8, ["label"])
          ])
        ], 32),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t("theme.org.form.colors")), 1),
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("theme.org.primary")), 1),
          _createVNode(_component_PreviewColors, {
            color: _ctx.colors?.primary
          }, null, 8, ["color"]),
          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("theme.org.secondary")), 1),
          _createVNode(_component_PreviewColors, {
            color: _ctx.colors?.secondary
          }, null, 8, ["color"])
        ])
      ]))
}